import { Component, Inject, OnDestroy, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AdminScreenContextService } from '../../../shared/admin-screen-context.service';

@Component({
    selector: 'gtw-business-assign-request-approval',
    templateUrl: './business-assign-request-approval.component.html',
    styleUrls: ['./business-assign-request-approval.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BusinessAssignRequestApprovalComponent implements OnInit, OnDestroy {
  title: any;
  rowData: any = {
    SSO_ID: ''
  };
  minimise: any;
  requestApprovalScreen: any;
  index: any;

  constructor(
    private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private adminScreenContext: AdminScreenContextService
  ) {
    this.rowData.SSO_ID = data.globalService.userSettingsData.user.sso_id;
    this.requestApprovalScreen = true;
    this.index = data.index;
  }

  ngOnInit(): void {
    this.title = "Assign Business";
    this.adminScreenContext.setRowData(this.rowData);
  }

  ngOnDestroy(): void {
    this.adminScreenContext.clear();
  }

  cancel(): void {
    this.dialog.closeAll();

  }
  
  eventType(type: any): void {
    if(type == 'cancel') {
      this.cancel();
    } else {
      this.title = type;
    }
  }
}
